module.exports = __webpack_public_path__ + "img/NotOpen.91d3e241.svg";